import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

const STRINGS = appStrings.modules.start.whatIsACareerTrackModal;

export const useAgentContext = () => {
  useRegisterAgentContext({
    kind: 'section',
    title: STRINGS.topLeftSection.title,
    description:
      'Defines career tracks with a title, descriptive text, and a static diagram of the five tiers.',
    detail: STRINGS.topLeftSection.description,
  });

  useRegisterAgentContext({
    kind: 'section',
    title: STRINGS.middleSection1.title,
    description:
      'Explains how people can move between career tracks over time, with an illustration of track change.',
    detail: STRINGS.middleSection1.description,
  });

  useRegisterAgentContext({
    kind: 'section',
    title: STRINGS.middleSection2.title,
    description:
      'Explains how compensation differs across career tracks, with an interactive bar chart and color-coded track labels.',
    detail: STRINGS.middleSection2.description,
  });

  useRegisterAgentContext({
    kind: 'visual',
    label: 'Career Track Compensation Chart',
    display:
      'Interactive bar chart showing compensation ranges by career track tier. Hovering over each bar shows the annual salary range.',
    data: STRINGS.tierSalaryData,
  });
};
